import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { i18n } from "@/i18n/index.js";

const { t } = i18n.global;

configure({
  generateMessage: localize("fr", {
    messages: {
      required: (data) => t("other.validation.required", { field: data.field }),
      email: () => t("other.validation.email"),
      password: () => t("other.validation.password"),
      textOnly: () => t("other.validation.textOnly"),
      min: (data) => t("other.validation.min", { length: data.rule.params[0] }),
      max: (data) => t("other.validation.max", { length: data.rule.params[0] }),
      postalCode: () => t("other.validation.postalCode"),
      match: () => t("other.validation.match"),
      is_not: () => t("other.validation.is_not"),
      not_included: () => t("other.validation.not_included"),
      vat: () => t("other.validation.vat"),
    },
  }),
});
